import React from 'react'
import './privateActivity.css'

class PrivateActivity extends React.PureComponent {

  render() {
    const {activityName} = this.props
    return (
      <div className='private-activity'>
        <h1>{activityName} activity is private.</h1>
        <span>Only this user has access to their {activityName} activity</span>
      </div>
    )
  }
}

export default PrivateActivity



// WEBPACK FOOTER //
// ./src/domains/user/components/PrivateActivity.js